<template>
  <a-modal
    :visible="visible"
    :mask-closable="false"
    width="380px"
    @cancel="handleCancel"
  >
    <div class="content">
      <div class="icon-row">
        <a-icon type="warning" theme="filled" class="warning-icon" />
      </div>

      <div style="flex: 1;">
        <div class="title">操作确认</div>
        <div class="desc">
          确认删除该客户端？
        </div>
      </div>
    </div>
    <div slot="footer" class="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="danger" ghost :loading="loading" @click="handleOk">确认</a-button>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'RemoveTenantClient',
  props: {
    visible: { type: Boolean, default: false },
    record: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handleOk() {
      this.loading = true
      this.$emit('confirm', () => { this.loading = false })
    },
    handleCancel() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  display: flex;

  .icon-row {
    width: 36px;
    height: 36px;
    margin-right: 12px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff2f0;
  }
  .warning-icon {
    font-size: 14px;
    color: #ff4d4f;
  }
  .title {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    color: #151515;
    margin-bottom: 10px;
  }
  .desc {
    text-align: left;
    font-size: 13px;
    color: #595959;
    line-height: 1.7;
  }
}

.footer { text-align: right; }
</style>
